<template>
  <TransitionGroup
    name="navigation-title"
    tag="div"
    class="h-full flex flex-row items-center justify-start overflow-hidden"
  >
    <div
      v-if="navigationTitlePrefix.visible"
      key="prefix"
      class="navigation-title-item-prefix hidden flex-shrink-0 mobile-m:block"
    >
      <Transition
        name="el-fade-in-linear"
        mode="out-in"
        appear
      >
        <p class="flex flex-col items-end text-white pr-20 mr-20 border-r-2 border-white mobile:pr-15
        mobile:mr-15">
          <span class="block font-medium text-lg leading-tight mobile:text-base">
            {{ navigationTitlePrefix.monthAndDay }}
          </span>
          <span class="block text-xs leading-tight mt-2 mobile:mt-0">
            {{ navigationTitlePrefix.time }}
          </span>
        </p>
      </Transition>
    </div>
    <div
      key="main"
      class="h-full flex items-center overflow-hidden"
    >
      <Transition
        name="el-fade-in-linear"
        mode="out-in"
        appear
      >
        <div>
          <h1 class="font-normal text-lg leading-tight text-white truncate">
            {{ mainNavigationTitle }}
          </h1>
          <div
            v-if="$route.name === 'EventDetails'"
            class="block text-xs leading-tight mt-2 mobile:mt-0 flex"
          >
            <p v-if="navigationTitlePrefix.pack" class="uppercase">
              {{ navigationTitlePrefix.pack.fields.shortName }},
            </p>
            <p  class="ml-3">max {{ navigationTitlePrefix.maxGuests }} guests</p>
          </div>
        </div>
      </Transition>
    </div>
  </TransitionGroup>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { systemIsSupportingIntl, systemIsHour12, getSystemLocale } from '@/utils/intl';

const simpleTimeFormat = { // TODO: Extract
  hour12: systemIsHour12,
  hour: '2-digit',
  minute: '2-digit',
};
const monthAndDayFormat = { // TODO: Extract
  hour12: systemIsHour12,
  month: 'short',
  day: 'numeric',
};

export default {

  data: () => ({
    navigationTitlePrefix: {
      visible: false,
      monthAndDay: '',
      time: '',
      maxGuests: '',
      pack: null,
    },
  }),
  watch: {
    $route: {
      immediate: true,
      handler(newRoute) {
        this.updateNavigationTitle(newRoute);
      },
    },
    currentEvent: {
      handler(newEventData) {
        if (!newEventData || this.$route.name !== 'EventDetails') return;
        // Events being created/updated can momentarily lack a Firestore Timestamp (Sentry EVENTOR-VUEJS-MA)
        if (typeof newEventData.startingTime?.toDate !== 'function') return;

        const eventStartingTime = newEventData.startingTime.toDate();
        this.navigationTitlePrefix.maxGuests = newEventData.maxGuests;
        const currentPack = this.packages.find((pack) => pack.id === newEventData.packageId);

        this.navigationTitlePrefix.visible = true;
        this.navigationTitlePrefix.pack = currentPack;

        if (!systemIsSupportingIntl) {
          this.navigationTitlePrefix.monthAndDay = eventStartingTime
            .toLocaleString(getSystemLocale(), monthAndDayFormat);
          this.navigationTitlePrefix.time = eventStartingTime
            .toLocaleString(getSystemLocale(), simpleTimeFormat);

          return;
        }

        this.navigationTitlePrefix.monthAndDay = new Intl.DateTimeFormat(getSystemLocale(), monthAndDayFormat)
          .format(eventStartingTime);
        this.navigationTitlePrefix.time = new Intl.DateTimeFormat(getSystemLocale(), simpleTimeFormat)
          .format(eventStartingTime);
      },
    },
  },
  computed: {
    ...mapState('packages', {
      packages: 'packageDocs',
    }),
    ...mapState('user/events', {
      allEvents: 'all',
    }),
    ...mapGetters('navigation', {
      prefixNavigationTitle: 'prefixNavigationTitle',
      mainNavigationTitle: 'mainNavigationTitle',
    }),
    currentEvent() {
      return this.allEvents[this.$route.params.eventID];
    },
  },
  methods: {
    updateNavigationTitle(newRoute) {
      const currentNavigationTitleBase = newRoute.meta.defaultBaseNavigationTitle || newRoute.name;

      if (newRoute.meta.noBaseTitleHandling) {
        this.$store.commit('navigation/SET_INIT_NAVIGATION_TITLE_BASE', `${currentNavigationTitleBase} `);
      } else {
        this.$store.commit('navigation/INIT_CURRENT_NAVIGATION_TITLE_BASE', `${currentNavigationTitleBase} `);
      }

      if (newRoute.name !== 'EventDetails') {
        this.navigationTitlePrefix.visible = false;
      }
    },
  },
};
</script>

<style scoped>
/* Transitions */
.navigation-title-enter, .navigation-title-leave-to {
  @apply opacity-0;

  transform: translateX(-40px);
}

.navigation-title-leave-active {
  @apply absolute;
}

.navigation-title-move {
  transition: all 0.3s;
}

.navigation-title-item-prefix {
  transition: transform 0.3s;
}
</style>
